(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/data/exclusion.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/data/exclusion.js');

'use strict';

function getDependencies() {
  if (typeof exports === 'object') {
    return require('./definitions.es6');
  }
  return svs.accountservices.player_exclusions.definitions;
}
const _getDependencies = getDependencies(),
  verticals = _getDependencies.verticals,
  pauseTypes = _getDependencies.pauseTypes;
class Exclusion {
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$needSelfTest = _ref.needSelfTest,
      needSelfTest = _ref$needSelfTest === void 0 ? false : _ref$needSelfTest,
      selfTestExpiry = _ref.selfTestExpiry,
      expiry = _ref.expiry,
      _ref$isExpired = _ref.isExpired,
      isExpired = _ref$isExpired === void 0 ? false : _ref$isExpired,
      type = _ref.type,
      vertical = _ref.vertical;
    this.expiry = expiry;
    this.isExpired = isExpired;
    this.needSelfTest = needSelfTest;
    this.selfTestExpiry = selfTestExpiry;
    this.type = type;
    this.vertical = vertical;
  }
  get is24HourExclusion() {
    return this.type === pauseTypes.GamingPause24 || this.type === pauseTypes.PauseTwentyFourHours || this.type === pauseTypes.PauseTwentyFourHoursGcs;
  }
  get gcsVertical() {
    let gcsVertical;
    switch (this.vertical) {
      case verticals.ALLA:
        gcsVertical = 'All';
        break;
      case verticals.BINGO:
        gcsVertical = 'Bingo';
        break;
      case verticals.CASINO:
        gcsVertical = 'NetCasino';
        break;
      case verticals.POKER:
        gcsVertical = 'Poker';
        break;
      case verticals.SPORT:
        gcsVertical = 'SportsBetting';
        break;
      default:
    }
    return gcsVertical;
  }
  toString() {
    return this.vertical;
  }
}
if (typeof exports === 'object') {
  module.exports = {
    Exclusion
  };
} else {
  svs.accountservices.player_exclusions.Exclusion = Exclusion;
}

 })(window);